import React__default from 'react';
import KKeycloakCredentialAuthButton from '../LandingPage/KKeycloakCredentialAuthButton/index.js';
import KKeycloakGuestAuthButton from '../LandingPage/KKeycloakGuestAuthButton/index.js';
import KLandingRequestAccount from '../LandingPage/KLandingRequestAccount/index.js';
import { DisplayMode } from '../LandingPage/types.js';

function addAuthButtonComponents(idpConfigured, loginUrl, bottomComponents, guestLoginUrl, requestAccountUrl, labels) {
    if (idpConfigured && loginUrl) {
        bottomComponents.push(React__default.createElement(KKeycloakCredentialAuthButton, { loginUrl: loginUrl, labels: labels, defaultDisplayMode: DisplayMode.Headband }));
    }
    if (guestLoginUrl) {
        bottomComponents.push(React__default.createElement(KKeycloakGuestAuthButton, { loginUrl: guestLoginUrl, labels: labels }));
    }
    if (requestAccountUrl) {
        bottomComponents.push(React__default.createElement(KLandingRequestAccount, { href: requestAccountUrl, labels: labels }));
    }
}

export { addAuthButtonComponents };
//# sourceMappingURL=utils.js.map
